import { getData } from "../lib/fetchApi";
import { RECOMMENDATIONS_URLS } from "../constants/urls";

const recommendationsService = {
    getByBasket: (limit = 10) => {
        return getData({ url: RECOMMENDATIONS_URLS.BY_BASKET + `?limit=${limit}` });
    },
};

export default recommendationsService;
